/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IInvoicesListViewProps } from './nos-invoices-list';

export const InvoiceListView: React.FC<IInvoicesListViewProps> = props => {
    const { header, filter, content, invoiceRequestModal, pagination } = props;

    return (
        <Module {...props.moduleProps}>
            {header}
            {invoiceRequestModal}
            {filter}
            {content}
            {pagination}
        </Module>
    );
};

export default InvoiceListView;
